import {xrStore} from 'lib';
import {useARStore} from 'stores';

interface IHitTestFromScreenProps {
  screenX: number;
  screenY: number;
  entityTypes?: XRHitTestTrackableType[];
}

/**
 * Hit test from camera/viewer according to NDC position on screen.
 * @param props screen X and Y positions on screen, [-1, 1].
 * @returns Hit test transforms.
 */

const hitTestFromScreen = async (props?: IHitTestFromScreenProps) => {
  let transforms: XRRigidTransform[] = [];
  const session = xrStore.getState().session;
  const fieldOfView = useARStore.getState().fieldOfView;
  if (!session || !fieldOfView) {
    return transforms;
  }
  const relativeTo = await session.requestReferenceSpace('viewer');
  const screenX = props?.screenX ?? 0;
  const screenY = props?.screenY ?? 0;
  const offsetRay = new XRRay(
    {x: 0, y: 0, z: 0, w: 1},
    {
      x: fieldOfView.maxX * screenX,
      y: fieldOfView.maxY * screenY,
      z: -1,
      w: 0,
    },
  );
  const source = await session.requestHitTestSource?.({
    space: relativeTo,
    offsetRay,
    entityTypes: props?.entityTypes ?? ['mesh', 'plane', 'point'],
  });
  if (!source) {
    return transforms;
  }
  const frame = await xrStore.requestFrame();
  const results = frame.getHitTestResults(source);
  const baseSpace = xrStore.getState().originReferenceSpace;
  source.cancel();
  if (!baseSpace) {
    return transforms;
  }
  transforms = results.map(r => r.getPose(baseSpace)?.transform).filter(Boolean) as XRRigidTransform[];
  return transforms;
};

export default hitTestFromScreen;
